module.exports = __webpack_public_path__ + "static/media/details1.62179b35.svg";